import { ReactNode } from 'react';
import { IControlProps, IPartialFormGroup } from '../types';
import FormControl from '../FormControl';
import InputNumber, { IInputNumberProps } from '../../atoms/InputNumber';
import { useHookFormController } from '../../hooks/useHookFormController';

export type IInputNumberControlProps = Omit<IInputNumberProps, 'onValueChange'> &
    IControlProps & {
        /** Значение на каждый ввод — числом (`null` — поле очищено), только если оно изменилось */
        onValueChange?: (value: number | null) => void;
        formGroupProps?: IPartialFormGroup;
        label?: ReactNode;
        tooltip?: ReactNode;
        required?: boolean;
        isValueAsString?: boolean;
    };

const InputNumberControl = ({
    name,
    rules,
    defaultValue,
    control,
    shouldUnregister,
    label,
    tooltip,
    required,
    formGroupProps,
    hideErrorMessage,
    isValueAsString,
    ...props
}: IInputNumberControlProps) => {
    const Controller = useHookFormController();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            shouldUnregister={shouldUnregister}
            defaultValue={defaultValue}
            render={({ field: { onChange, value, ...fieldProps } }) => (
                <FormControl
                    readonlyAppearance={props.readOnly || props.disabled ? 'input' : undefined}
                    name={name}
                    label={label}
                    tooltip={tooltip}
                    required={required}
                    control={control}
                    hideErrorMessage={hideErrorMessage}
                    {...formGroupProps}
                >
                    <InputNumber
                        {...fieldProps}
                        {...props}
                        defaultValue={value}
                        onValueChange={(val) => {
                            const rawValue = val.replace(/\s/g, '');
                            if (
                                value === undefined ||
                                value === null ||
                                value === 0 ||
                                value === '0' ||
                                value.toString() != (+rawValue).toString()
                            ) {
                                let valResult = val == '' ? null : +rawValue;
                                onChange(isValueAsString ? (valResult == null ? '' : valResult.toString()) : valResult);
                                if (props.onValueChange) {
                                    props.onValueChange(valResult);
                                }
                            }
                        }}
                    />
                </FormControl>
            )}
        />
    );
};

export default InputNumberControl;
